import { useEffect, useState } from "react";
import { useOutletContext } from 'react-router-dom';
import axios from "axios";
import Swal from "sweetalert2";
// COMPONENTE
import ZonaCargando from "../alertas/zonaCargando";
import ListaDesembolsos from "../../componentesEspeciales/desembolsosPagos/listaReservas";
// FUNCIONES
import { formatearFechaHora } from "../../funcionesDatos/fechas";
import { formatearMoneda } from "../../funcionesDatos/Moneda";
// Réplica del fee de Wompi Pagos a Terceros (backend/funciones/variables.js -> calcularFeeWompiPayout)
// para poder calcular en el frontend, sin ida y vuelta al servidor, cuánto es el monto NETO máximo
// que se puede pedir sin que "monto + su propia comisión" se pase del saldo seguro disponible.
function calcularFeeWompiPayoutFrontend(monto) {
    const porcentaje = 0.004; // 0,4%
    const fijo       = 1849;  // COP
    const tasaIva     = 0.19;  // IVA sobre la tarifa de Wompi
    const base = (monto * porcentaje) + fijo;
    const iva  = base * tasaIva;
    return Math.round(base + iva);
}

function calcularMontoMaximoSeguro(saldoSeguro) {
    const saldo = Number(saldoSeguro || 0);
    if (saldo <= 0) return 0;

    // Despeje algebraico de: monto + fee(monto) = saldo, ignorando el redondeo del fee.
    const k = 1 + (0.004 * 1.19);
    const c = 1849 * 1.19;
    let monto = Math.floor((saldo - c) / k);
    if (monto <= 0) return 0;

    // Ajuste fino por el redondeo real de calcularFeeWompiPayoutFrontend.
    while (monto > 0 && (monto + calcularFeeWompiPayoutFrontend(monto)) > saldo) {
        monto -= 1;
    }
    return monto;
}

function Desembolsos() {

    const { usuario, cargandoUsuario, setUsuario, entornoApp, ahoraServidor } = useOutletContext() || {}; // variables que vienen de direccionameinto 
    const [cargando, setCargando]   = useState(false);
    const cargandoFinal             = Boolean(cargandoUsuario) || Boolean(cargando);

    const [desembolsos, setDesembolsos]               = useState([]);
    const [totalVendedores, setTotalVendedores]       = useState(0);
    const [totalReservas, setTotalReservas]           = useState(0);
    const [totalAPagarGeneral, setTotalAPagarGeneral] = useState(0);
    const [totalDescuentoGeneral, setTotalDescuentoGeneral]         = useState(0);
    const [totalConDescuentoGeneral, setTotalConDescuentoGeneral]   = useState(0);
    const [ahoraDesembolsos, setAhoraDesembolsos]     = useState(null);
    const [saldoWompi, setSaldoWompi]                 = useState(null);
    const [montoEnVuelo, setMontoEnVuelo]             = useState(0);
    const [saldoSeguro, setSaldoSeguro]                = useState(null);
    const [cargandoSaldo, setCargandoSaldo]           = useState(false);
    const [paginaActual, setPaginaActual]             = useState(1);
    const [tipoDesembolsos, setTipoDesembolsos]       = useState("por_enviar");
    const [montoEmpresa, setMontoEmpresa]             = useState("");
    const [enviandoEmpresa, setEnviandoEmpresa]       = useState(false);
    const opcionesTipoDesembolsos = [
        { valor: "por_enviar", texto: "Por enviar", descripcion: "Vendedores con pagos pendientes listos para programar o enviar." },
        { valor: "programados", texto: "Programados", descripcion: "Desembolsos ya programados y pendientes de confirmación." },
        { valor: "enviados", texto: "Enviados", descripcion: "Desembolsos enviados o pagados anteriormente." },
        { valor: "fallidos", texto: "Fallidos", descripcion: "Desembolsos que Wompi rechazó — revisa el motivo y reintenta." },
    ];
    const desembolsosPorPagina                        = 10;

    function mostrarMoneda(valor, moneda = "COP") {
        return formatearMoneda(Number(valor || 0), moneda);
    }

    function mostrarFechaHora(fecha) {
        return formatearFechaHora(fecha) || "NA";
    }

    // Saca el detalle real que Wompi devolvió (err.response.data.errorWompi), sea objeto o string.
    function extraerDetalleErrorWompi(err) {
        const errorWompi = err?.response?.data?.errorWompi;
        if (!errorWompi) return null;
        if (typeof errorWompi === "string") return errorWompi;
        return errorWompi?.message || errorWompi?.data?.message || errorWompi?.error || JSON.stringify(errorWompi);
    }

    function textoCorteCalculado() {
        if (tipoDesembolsos === "programados") {
            return "Mostrando desembolsos con fecha de programación registrada.";
        }
        if (tipoDesembolsos === "enviados") {
            return "Mostrando desembolsos con fecha de pago registrada.";
        }
        if (tipoDesembolsos === "fallidos") {
            return "Mostrando desembolsos que Wompi rechazó — revisa el motivo antes de reintentar.";
        }
        return "Mostrando pagos pendientes cuya fecha disponible para pago es igual o anterior a esta fecha.";
    }

    const totalPaginas = Math.max(1, Math.ceil(desembolsos.length / desembolsosPorPagina));
    const inicioPagina = (paginaActual - 1) * desembolsosPorPagina;
    const finPagina = inicioPagina + desembolsosPorPagina;
    const desembolsosPagina = desembolsos.slice(inicioPagina, finPagina);

    function irPaginaAnterior() {
        setPaginaActual((pagina) => Math.max(1, pagina - 1));
    }

    function irPaginaSiguiente() {
        setPaginaActual((pagina) => Math.min(totalPaginas, pagina + 1));
    }

    function cambiarTipoDesembolsos(nuevoTipo) {
        if (nuevoTipo === tipoDesembolsos) return;
        setTipoDesembolsos(nuevoTipo);
        setPaginaActual(1);
    }

 
    async function obtenerSaldoWompi() {
        try {
            setCargandoSaldo(true);
            const res = await axios.post("/obtener-saldo-wompi-terceros");
            const data = res?.data || {};
            setSaldoWompi(data?.exito ? Number(data.saldoDisponible || 0) : null);
            setMontoEnVuelo(data?.exito ? Number(data.montoEnVueloVendedores || 0) : 0);
            setSaldoSeguro(data?.exito ? Number(data.saldoDisponibleSeguro || 0) : null);
        }
        catch (err) {
            console.log("Error obteniendo saldo Wompi:", err);
            setSaldoWompi(null);
            setMontoEnVuelo(0);
            setSaldoSeguro(null);
        }
        finally { setCargandoSaldo(false); }
    }

    async function pagarTodosLosDesembolsos() {
        try {
            if (tipoDesembolsos !== "por_enviar") return;

            if (saldoWompi !== null && totalAPagarGeneral > saldoWompi) {
                return Swal.fire({
                    icon: "warning",
                    title: "Saldo insuficiente en Wompi",
                    html: `
                        <div style="text-align:left; font-size:16px; line-height:1.6;">
                            <p style="margin-bottom:10px;">El saldo disponible en Wompi no alcanza para pagar todos los desembolsos de esta lista.</p>
                            <p style="margin-bottom:10px;"><b>Disponible en Wompi:</b> ${mostrarMoneda(saldoWompi, "COP")}</p>
                            <p style="margin-bottom:0;"><b>Total a pagar:</b> ${mostrarMoneda(totalAPagarGeneral, "COP")}</p>
                        </div>
                    `,
                    confirmButtonText: "Entendido",
                    customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
                });
            }

            const pagos = desembolsos
                .map((desembolso) => {
                    const idProveedor = desembolso?.idProveedor || desembolso?._id || desembolso?.proveedor?._id || desembolso?.proveedor?.idProveedor;
                    const reservas    = Array.isArray(desembolso?.reservas) ? desembolso.reservas : [];
                    const idsReservas = reservas
                        .map((reserva) => reserva?._id || reserva?.idReserva)
                        .filter(Boolean);

                    return { idProveedor, idsReservas };
                })
                .filter((pago) => pago?.idProveedor && Array.isArray(pago?.idsReservas) && pago.idsReservas.length > 0);

            if (pagos.length === 0) {
                return Swal.fire({
                    icon: "info",
                    title: "Sin desembolsos por pagar",
                    text: "No encontramos reservas válidas para enviar a Wompi.",
                    confirmButtonText: "Entendido",
                    customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
                });
            }

            const confirmar = await Swal.fire({
                icon: "warning",
                title: "¿Pagar todos los desembolsos?",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:10px;">Se enviarán a Wompi Pagos a Terceros los desembolsos pendientes de esta lista.</p>
                        <p style="margin-bottom:10px;"><b>Vendedores:</b> ${pagos.length}</p>
                        <p style="margin-bottom:10px;"><b>Reservas:</b> ${Number(totalReservas || 0)}</p>
                        <p style="margin-bottom:0;"><b>Total:</b> ${mostrarMoneda(totalAPagarGeneral, "COP")}</p>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Sí, pagar todos",
                cancelButtonText: "Cancelar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar", cancelButton: "mi-boton-cancelar" },
            });

            if (!confirmar.isConfirmed) return;

            setCargando(true);

            const res = await axios.post("/pagar-todos-desembolsos", {
                params: { pagos },
            });

            setCargando(false);
            
            await Swal.fire({
                icon: "success",
                title: "Desembolsos enviados",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:10px;">Los pagos fueron enviados correctamente a Wompi Pagos a Terceros.</p>
                        <p style="margin-bottom:10px;"><b>Vendedores procesados:</b> ${res?.data?.totalVendedores || pagos.length}</p>
                        <p style="margin-bottom:10px;"><b>Reservas procesadas:</b> ${res?.data?.totalReservas || totalReservas || "NA"}</p>
                        <p style="margin-bottom:10px;"><b>Referencia lote:</b> ${res?.data?.wompi?.referenciaLote || res?.data?.referenciaLote || "NA"}</p>
                        <p style="margin-bottom:0;">El estado final se actualizará automáticamente cuando Wompi envíe el webhook correspondiente.</p>
                    </div>
                `,
                confirmButtonText: "Continuar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });

            setTipoDesembolsos("programados");
            setPaginaActual(1);
        }
        catch (err) {
            console.log("Error pagando todos los desembolsos:", err);

            const mensajeGeneral = err?.response?.data?.mensaje || "Ocurrió un error enviando los pagos masivos a Wompi.";
            const detalleWompi   = extraerDetalleErrorWompi(err);

            await Swal.fire({
                icon: "error",
                title: "No se pudieron enviar los desembolsos",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:${detalleWompi ? "10px" : "0"};">${mensajeGeneral}</p>
                        ${detalleWompi ? `<p style="margin-bottom:0;"><b>Wompi respondió:</b> ${detalleWompi}</p>` : ""}
                    </div>
                `,
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
        finally {
            setCargando(false);
        }
    }

    useEffect(() => {
        (async () => {
            try {
                setCargando(true);

                // OBTENER DESEMBOLSOS SEGÚN EL FILTRO SELECCIONADO
                const resDese = await axios.post("/obtener-desembolsos", {
                    params: { tipoDesembolsos },
                });
                const data = resDese?.data || {};
                console.log("resDesde: ", data);

                setDesembolsos(Array.isArray(data?.desembolsos) ? data.desembolsos : []);
                setPaginaActual(1);
                setTotalVendedores(Number(data?.totalVendedores || 0));
                setTotalReservas(Number(data?.totalReservas || 0));
                setTotalAPagarGeneral(Number(data?.totalAPagarGeneral || 0));
                setTotalDescuentoGeneral(Number(data?.totalDescuentoGeneral || 0));
                setTotalConDescuentoGeneral(Number(data?.totalConDescuentoGeneral || 0));
                setAhoraDesembolsos(data?.ahora || null);
            }
            catch (err) {
                console.log("Error obteniendo desembolsos:", err);
                setDesembolsos([]);
                setTotalVendedores(0);
                setTotalReservas(0);
                setTotalAPagarGeneral(0);
                setTotalDescuentoGeneral(0);
                setTotalConDescuentoGeneral(0);
                setAhoraDesembolsos(null);
            }
            finally { setCargando(false); }
        })();
        }, [tipoDesembolsos]);

    useEffect(() => {
        obtenerSaldoWompi();
        }, []);

    function usarMontoMaximoSeguro() {
        const maximo = calcularMontoMaximoSeguro(saldoSeguro);
        if (maximo <= 0) return;
        setMontoEmpresa(String(maximo));
    }

    async function enviarDesembolsoEmpresa() {
        try {
            const monto = Number(montoEmpresa);
            if (!monto || monto <= 0) {
                return Swal.fire({ icon: "error", title: "Falta el monto", text: "Ingresa cuánto quieres enviar a la cuenta de la empresa.", customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" } });
            }

            const confirmar = await Swal.fire({
                icon: "warning",
                title: "¿Enviar a la cuenta de la empresa?",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:10px;">Se enviará vía Wompi Pagos a Terceros a:</p>
                        <p style="margin-bottom:10px;"><b>Bancolombia · Ahorros · 22900004424</b><br/>PRETWOR SAS</p>
                        <p style="margin-bottom:0;"><b>Monto:</b> ${mostrarMoneda(monto, "COP")}</p>
                    </div>
                `,
                showCancelButton: true,
                confirmButtonText: "Sí, enviar",
                cancelButtonText: "Cancelar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar", cancelButton: "mi-boton-cancelar" },
            });

            if (!confirmar.isConfirmed) return;

            setEnviandoEmpresa(true);
            const res = await axios.post("/pagar-desembolso-empresa", { params: { monto } });
            setEnviandoEmpresa(false);
            setMontoEmpresa("");

            await Swal.fire({
                icon: "success",
                title: "Enviado",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:10px;">El desembolso a la cuenta de la empresa fue creado en Wompi y ya quedó registrado para la conciliación.</p>
                        <p style="margin-bottom:0;"><b>Estado inicial:</b> ${res?.data?.wompi?.estado || "NA"}</p>
                    </div>
                `,
                confirmButtonText: "Continuar",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });

            obtenerSaldoWompi();
        }
        catch (err) {
            console.log("Error enviando desembolso a la empresa:", err);
            setEnviandoEmpresa(false);

            const mensajeGeneral = err?.response?.data?.mensaje || "Ocurrió un error enviando el desembolso.";
            const detalleWompi   = extraerDetalleErrorWompi(err);

            await Swal.fire({
                icon: "error",
                title: "No se pudo enviar",
                html: `
                    <div style="text-align:left; font-size:16px; line-height:1.6;">
                        <p style="margin-bottom:${detalleWompi ? "10px" : "0"};">${mensajeGeneral}</p>
                        ${detalleWompi ? `<p style="margin-bottom:0;"><b>Wompi respondió:</b> ${detalleWompi}</p>` : ""}
                    </div>
                `,
                confirmButtonText: "Entendido",
                customClass: { popup: "mi-modal", confirmButton: "mi-boton-confirmar" },
            });
        }
    }


    return (
        <div>
            {cargandoFinal ? <ZonaCargando /> 
            : usuario ?
            <div className="container-fluid">
                {/* Contenedor título */}
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center gap-3 pt-3 pb-2 mb-3 border-bottom">
                    <div>
                        <h1 className="h2 text-dark mb-1">Desembolsos</h1>
                        <p className="text-secondary mb-0">
                            {opcionesTipoDesembolsos.find((opcion) => opcion.valor === tipoDesembolsos)?.descripcion || "Administra los desembolsos de vendedores."}
                        </p>
                    </div>
                    {tipoDesembolsos === "por_enviar" && (
                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
                        onClick={pagarTodosLosDesembolsos}
                        disabled={totalVendedores === 0 || totalAPagarGeneral <= 0}
                    >
                        <i className="bi bi-send-check me-2"></i>
                        Pagar todos los desembolsos
                    </button>
                    )}
                </div>
                

                {/* FILTROS DE ESTADO */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body p-2">
                        <div className="d-flex flex-column flex-md-row gap-2">
                            {opcionesTipoDesembolsos.map((opcion) => {
                                const activo = tipoDesembolsos === opcion.valor;
                                return (
                                    <button
                                        key={opcion.valor}
                                        type="button"
                                        className={`btn rounded-pill fw-semibold flex-fill ${activo ? "btn-primary" : "btn-light text-secondary"}`}
                                        onClick={() => cambiarTipoDesembolsos(opcion.valor)}
                                    >
                                        {opcion.texto}
                                    </button>
                                );
                            })}
                        </div>
                    </div>
                </div>

                {/* ENVIAR DESEMBOLSO A LA CUENTA DE LA EMPRESA */}
                <div className="card border-0 shadow-sm rounded-4 mb-4">
                    <div className="card-body p-3">
                        <h6 className="fw-bold mb-1">Enviar desembolso a la cuenta de la empresa</h6>
                        <p className="text-secondary small mb-3">
                            Bancolombia · Ahorros · 22900004424 · PRETWOR SAS. Va directo por Wompi Pagos a Terceros (sin doble aprobación del dashboard) y queda registrado solo para la conciliación.
                        </p>

                        {!cargandoSaldo && saldoSeguro !== null && (
                            <div className={`rounded-3 p-2 mb-3 ${saldoSeguro < 0 ? "border border-danger" : ""}`} style={{ background: saldoSeguro < 0 ? "rgba(var(--rojo-error-rgb), 0.06)" : "var(--color-track-bg)", fontSize: "0.85rem" }}>
                                <div>Saldo disponible en Wompi: <strong>{mostrarMoneda(saldoWompi, "COP")}</strong></div>
                                {montoEnVuelo > 0 && (
                                    <div className="text-secondary">
                                        En proceso con vendedores (programado, sin confirmar): {mostrarMoneda(montoEnVuelo, "COP")}
                                        <span className="fw-normal"> — Wompi ya lo descontó del saldo de arriba.</span>
                                    </div>
                                )}
                                {saldoSeguro < 0 ? (
                                    <div className="fw-bold text-danger">
                                        ⚠️ El saldo de Wompi está en negativo ({mostrarMoneda(saldoSeguro, "COP")}). Revisa el dashboard de Wompi antes de enviar cualquier pago.
                                    </div>
                                ) : (
                                    <div className="fw-semibold text-success">
                                        Disponible seguro para enviar: {mostrarMoneda(saldoSeguro, "COP")}
                                        <span className="text-secondary fw-normal"> (ya incluye la comisión de Wompi que se descuenta de este mismo saldo)</span>
                                    </div>
                                )}
                            </div>
                        )}

                        <div className="d-flex flex-wrap gap-2">
                            <input
                                type="number"
                                className="form-control"
                                placeholder="Monto a enviar"
                                style={{ maxWidth: "220px" }}
                                value={montoEmpresa}
                                onChange={(e) => setMontoEmpresa(e.target.value)}
                            />
                            <button
                                type="button"
                                className="btn btn-outline-dark rounded-pill px-3 py-2 fw-semibold"
                                disabled={!saldoSeguro || saldoSeguro <= 0}
                                onClick={usarMontoMaximoSeguro}
                                title="Calcula el monto neto máximo que deja espacio para la comisión de Wompi, sin pasarte del saldo seguro"
                            >
                                Enviar todo lo disponible
                            </button>
                            <button
                                type="button"
                                className="btn btn-dark rounded-pill px-4 py-2 fw-semibold"
                                disabled={enviandoEmpresa}
                                onClick={enviarDesembolsoEmpresa}
                            >
                                <i className="bi bi-bank2 me-2"></i>
                                {enviandoEmpresa ? "Enviando..." : "Enviar a la empresa"}
                            </button>
                        </div>
                    </div>
                </div>




                {/* FILA 1 INFORMACIÓN: TOTAL, VENDEDORES, RESERVAS */}
                <div className="row g-3 mb-4">
                {/* total a pagar */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">
                                    {tipoDesembolsos === "enviados" ? "Total enviado" : tipoDesembolsos === "programados" ? "Total programado" : "Total a pagar"}
                                </span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{mostrarMoneda(totalAPagarGeneral, "COP")}</h3>
                            </div>
                        </div>
                    </div>

                    {/* vendedores */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">Vendedores</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{Number(totalVendedores || 0)}</h3>
                            </div>
                        </div>
                    </div>

                    {/* reservas incluidas */}
                    <div className="col-12 col-md-4">
                        <div className="card border-0 shadow-sm rounded-4 h-100">
                            <div className="card-body">
                                <span className="text-secondary fw-semibold">Reservas incluidas</span>
                                <h3 className="fw-bold text-dark mb-0 mt-1">{Number(totalReservas || 0)}</h3>
                            </div>
                        </div>
                    </div>
                </div>

                {totalDescuentoGeneral > 0 && (
                    <div className="alert alert-light border rounded-4 mb-4">
                        <i className="bi bi-gift-fill me-2" style={{ color: "var(--verde-esmeralda)" }}></i>
                        De este corte, <strong>{mostrarMoneda(totalDescuentoGeneral, "COP")}</strong> corresponden a descuentos de primera compra en {totalConDescuentoGeneral} reserva{totalConDescuentoGeneral !== 1 ? "s" : ""}.
                        Ese descuento sale de la comisión de Zervicy — no afecta lo que se le paga a estos vendedores.
                    </div>
                )}

                {tipoDesembolsos === "por_enviar" && (
                <div className={`alert ${saldoWompi !== null && totalAPagarGeneral > saldoWompi ? "alert-danger" : "alert-light border"} rounded-4 mb-4`}>
                    {cargandoSaldo ? (
                        <div>Consultando saldo disponible en Wompi...</div>
                    ) : saldoWompi === null ? (
                        <div>No fue posible consultar el saldo disponible en Wompi.</div>
                    ) : (
                        <div>
                            Saldo disponible en Wompi para enviar pagos: <strong>{mostrarMoneda(saldoWompi, "COP")}</strong>
                            {totalAPagarGeneral > saldoWompi && (
                                <span className="ms-2 fw-semibold">— No alcanza para pagar los {mostrarMoneda(totalAPagarGeneral, "COP")} de esta lista.</span>
                            )}
                        </div>
                    )}
                </div>
                )}

                {ahoraDesembolsos && (
                <div className="alert alert-light border rounded-4 mb-4">
                    <div>
                        Corte calculado con fecha: <strong>{mostrarFechaHora(ahoraDesembolsos)}</strong>
                    </div>
                    <div className="text-secondary mt-1" style={{ fontSize: "0.92rem" }}>
                        {textoCorteCalculado()}
                    </div>
                </div>
                )}
                {tipoDesembolsos === "por_enviar" && (
                <div className="d-flex justify-content-end mb-3">
                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
                        onClick={pagarTodosLosDesembolsos}
                        disabled={totalVendedores === 0 || totalAPagarGeneral <= 0}
                    >
                        <i className="bi bi-send-check me-2"></i>
                        Pagar todos los desembolsos
                    </button>
                </div>
                )}

                <ListaDesembolsos desembolsos={desembolsosPagina} totalAPagarGeneral={totalAPagarGeneral} totalVendedores={totalVendedores} totalReservas={totalReservas} ahoraDesembolsos={ahoraDesembolsos} tipoDesembolsos={tipoDesembolsos} />



                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mt-4 mb-4">
                    <div className="text-secondary fw-semibold">
                        Mostrando {desembolsos.length > 0 ? inicioPagina + 1 : 0} - {Math.min(finPagina, desembolsos.length)} de {desembolsos.length} vendedores
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary rounded-pill px-3"
                            onClick={irPaginaAnterior}
                            disabled={paginaActual === 1}
                        >
                            ← Anterior
                        </button>

                        <span className="fw-semibold text-dark px-2">
                            Página {paginaActual} de {totalPaginas}
                        </span>

                        <button
                            type="button"
                            className="btn btn-outline-primary rounded-pill px-3"
                            onClick={irPaginaSiguiente}
                            disabled={paginaActual === totalPaginas}
                        >
                            Siguiente →
                        </button>
                    </div>
                </div>
            </div>
            :null
        }
        </div>
    );
}

export default Desembolsos;